<template>
  <div class="">
    <h5>6. Файлы документов</h5>
    <input @change="apply" class="btn btn-info" type="file" />
    <h5 v-if="file" class="text-success">
      <div class="mt-4">
        <a :href="file" target="_blank" class="btn btn-warning mw">{{
          "download" | setText("скачать")
        }}</a>
      </div>
    </h5>
  </div>
</template>

<script>
export default {
  props: {
    file: {
      default: null,
    },
    doc: {
      default: "",
    },
  },
  methods: {
    async apply(event) {
      if (event.target.files && event.target.files.length > 0) {
        const file = event.target.files[0];
        this.$emit("input", file);
      }
    },
  },
  data() {
    return {};
  },
};
</script>